import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Trans } from 'react-i18next';
import { actionTanks } from '../../../actions/tanks_actions.jsx';

export class TankStatus extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (!this.props.item) {
            this.props.getTanks(this.props.filter);
        }
    }

    render() {
        const item = this.props.item;
        const isItem = item !== undefined;
        
        return (
            <div className="tank-status">
                {
                    isItem &&
                    <div>
                        <span>{item != null ? item.tankName : ""}</span>
                        <span style={{ marginLeft: "20px" }}><Trans>Tanks.balance</Trans>
                        </span><span>: {item != null ? item.volume : 0}</span>
                        </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        item: state.tanks.tanks.length > 0 ? state.tanks.tanks[0] : null,
        filter: state.tanks.filter
    };
}

export default connect(mapStateToProps, dispatch => bindActionCreators(actionTanks, dispatch))(TankStatus)